import { render, staticRenderFns } from "./CustomerInvoiceList.vue?vue&type=template&id=3b4a5a86&scoped=true"
import script from "./CustomerInvoiceList.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceList.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoiceList.vue?vue&type=style&index=0&id=3b4a5a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4a5a86",
  null
  
)

export default component.exports